import React, { useState, useEffect } from "react";
import "../Styles/home.css";
const ProgressBar = ({ value, color }) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setWidth(value);
    }, 500);
  }, [value]);

  const getColorClass = () => {
    switch (color) {
      case "blue":
        return "bg-[#3f78e0]";
      case "yellow":
        return "bg-[#fab758]";
      case "orange":
        return "bg-[#f78b77]";
      case "green":
        return "bg-[#45c4a0]";
      case "violet":
        return "bg-[#605dba]";
      case "pink":
        return "bg-[#d16b86]";
      default:
        return "bg-[#3f78e0]";
    }
  };

  return (
    <div className="w-full bg-gray-100 h-1">
      <div 
        className={`h-full transition-all duration-[2000] ease-out ${getColorClass()}`}
        style={{ width: `${width}%` }}
      />
    </div>
  );
};
export default function About() {
  const progressData = [
    { label: "Medical Facilities Availability", value: 100, color: "blue" },
    { label: "Referral Management Efficiency", value: 98, color: "yellow" },
    { label: "Beneficiary Satisfaction", value: 99, color: "orange" },
    { label: "Drug and Equipment Supply", value: 100, color: "green" },
    { label: "Patient Care Quality", value: 99, color: "violet" },
    { label: "Data and Records Accuracy", value: 100, color: "pink" },
  ];
  return (
    <>
      <div>
        <section className="wrapper background-gif">
          <div className="container !pt-10 !pb-36 xl:!pt-[4.5rem] lg:!pt-[4.5rem] md:!pt-[4.5rem] xl:!pb-40 lg:!pb-40 md:!pb-40 !text-center">
            <div className="flex flex-wrap mx-[-15px]">
              <div className="md:w-10/12 lg:w-8/12 xl:w-8/12 w-full flex-[0_0_auto] px-[15px] max-w-full !mx-auto">
                <h1 className="text-[calc(1.365rem_+_1.38vw)] font-bold leading-[1.2] xl:text-[2.4rem] !mb-3">
                  About Us
                </h1>
                <p className="lead lg:!px-[1.25rem] xl:!px-[1.25rem] xxl:!px-[2rem] leading-[1.65] text-[0.9rem] font-medium max-w-full">
                  ECHS (Ex-Servicemen Contributory Health Scheme).
                </p>
              </div>
            </div>
          </div>
        </section>
        <div className="wrapper !bg-[#ffffff]">
          <div className="container !pb-[4.5rem] xl:!pb-24 lg:!pb-24 md:!pb-24">
            <div className="flex flex-wrap mx-[-15px]">
              <div className="xl:w-12/12 lg:w-12/12 w-full flex-[0_0_auto] px-[15px] max-w-full !mx-auto">
                <div className="blog classic-view !mt-[-7rem]">
                  <article className="post mb-8">
                    <div className="card content-section">
                      <div className="card-body flex-[1_1_auto] p-[40px] xl:p-[2rem_2.5rem_1.25rem] lg:p-[2rem_2.5rem_1.25rem] md:p-[2rem_2.5rem_1.25rem] sm:pb-4 xsm:pb-4  ">
                        <div className="post-header !mb-[.9rem]">
                          <div className="inline-flex mb-[.4rem] uppercase tracking-[0.02rem] text-[0.7rem] font-bold text-[#aab0bc] relative align-top pl-[1.4rem] before:content-[''] before:absolute before:inline-block before:translate-y-[-60%] before:w-3 before:h-[0.05rem] before:left-0 before:top-2/4 before:bg-[#3f78e0]">
                            <a href="#" className="hover" rel="category">
                              Who we are
                            </a>
                          </div>
                          <h2
                            className="post-title mt-1 !leading-[1.35] !mb-0"
                            style={{ textAlign: "center" }}
                          >
                            <a
                              className="text-[#343f52] hover:text-[#3f78e0]"
                              href="blog-post.html"
                            >
                              Collaboration for Impact: A Project in Action
                            </a>
                          </h2>
                        </div>
                        <div className="!relative">
                          <p style={{ textAlign: "justify" }}>
                            Retired Armed Forces personnel till 2002 could avail
                            medical facilities only for specific high cost
                            surgery/treatment for a limited number of diseases
                            covered under the Army Group Insurance(Medical
                            Branch Scheme) (AGI(MBS)) and Armed Forces Group
                            Insurance Scheme(Management Information System)
                            (AFGIS (MIS)) schemes. These medicare schemes could
                            provide some relief to the ESM, but it was not a
                            comprehensive scheme as compared to and available
                            for other Central Government Employees. Therefore,
                            the requirement was felt of establishing a medicare
                            system which could provide quality medicare to the
                            retirees of the Armed Forces. Based on this noble
                            aim, and after detailed deliberations, a
                            comprehensive scheme has taken shape as ECHS,
                            authorised vide Government of India, Ministry of
                            Defence letter No 22(i) 01/US/D(Res) dated 30 Dec
                            2002. The ECHS was launched with effect from 01 Apr
                            2003. With the advent of this scheme. Ex-servicemen
                            pensioners and their dependants who were only
                            entitled for treatment in service hospital are now
                            authorised treatment, not only in service hospitals,
                            but also in those civil/private hospitals which are
                            specifically empanelled with the ECHS.
                          </p>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="bg-1 mb-5">
          <div className="container !pb-[4.5rem] xl:!pb-24 lg:!pb-24 md:!pb-24">
            <div className="flex flex-wrap mx-[-15px] !text-center mb-14 xl:!mb-20 lg:!mb-20 md:!mb-20"></div>
            <div className="flex flex-wrap mx-[-15px] xl:mx-[-35px] lg:mx-[-20px] mt-[-30px] xl:mt-0 lg:mt-0 md:mt-0 !text-center">
              <div className="md:w-6/12 lg:w-3/12 xl:w-3/12 w-full flex-[0_0_auto] px-[15px] xl:px-[35px] lg:px-[20px] max-w-full sm:mt-[30px] xsm:mt-[30px]">
                <img
                  src="assets/img/icons/lineal/megaphone.svg"
                  className="svg-inject icon-svg icon-svg-md !w-[2.6rem] !h-[2.6rem] text-[#3f78e0] text-blue !mb-3  m-[0_auto]"
                  alt="image"
                />
                <h4>Medical Facilities Availability</h4>
                <p className="!mb-2">
                  ECHS ensures that essential medical facilities are
                  consistently available to meet the healthcare needs of
                  ex-servicemen and their families.
                </p>
              </div>
              <div className="md:w-6/12 lg:w-3/12 xl:w-3/12 w-full flex-[0_0_auto] px-[15px] xl:px-[35px] lg:px-[20px] max-w-full sm:mt-[30px] xsm:mt-[30px]">
                <img
                  src="assets/img/icons/lineal/target.svg"
                  className="svg-inject icon-svg icon-svg-md !w-[2.6rem] !h-[2.6rem] text-[#45c4a0] text-green !mb-3 m-[0_auto]"
                  alt="image"
                />
                <h4>Patient Care Quality</h4>
                <p className="!mb-2">
                  With a strong emphasis on high standards, ECHS delivers
                  exceptional patient care, ensuring that beneficiaries receive
                  the best possible treatment and support.
                </p>
              </div>
              <div className="md:w-6/12 lg:w-3/12 xl:w-3/12 w-full flex-[0_0_auto] px-[15px] xl:px-[35px] lg:px-[20px] max-w-full sm:mt-[30px] xsm:mt-[30px]">
                <img
                  src="assets/img/icons/lineal/settings-3.svg"
                  className="svg-inject icon-svg icon-svg-md !w-[2.6rem] !h-[2.6rem] text-[#fab758] text-yellow !mb-3  m-[0_auto]"
                  alt="image"
                />
                <h4>Drug and Equipment Supply</h4>
                <p className="!mb-2">
                  ECHS maintains a reliable supply chain for necessary
                  medications and medical equipment, ensuring that patients
                  receive the treatments they require.
                </p>
              </div>
              <div className="md:w-6/12 lg:w-3/12 xl:w-3/12 w-full flex-[0_0_auto] px-[15px] xl:px-[35px] lg:px-[20px] max-w-full sm:mt-[30px] xsm:mt-[30px]">
                <img
                  src="assets/img/icons/lineal/bar-chart.svg"
                  className="svg-inject icon-svg icon-svg-md !w-[2.6rem] !h-[2.6rem] text-[#f78b77] text-orange !mb-3 m-[0_auto]"
                  alt="image"
                />
                <h4>Beneficiary Satisfaction</h4>
                <p className="!mb-2">
                  ECHS consistently achieves high levels of beneficiary
                  satisfaction, reflecting its commitment to meeting the
                  healthcare needs of its members.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="mb-5 pt-20">
          <div className="container !pb-[1.5rem] xl:!pb-12 lg:!pb-12 md:!pb-12">
            <div className="flex flex-wrap mx-[-15px] xl:mx-[-35px] lg:mx-[-20px] mt-[-30px] mb-10 items-start">
              {/* Left side content */}
              <div className="xl:w-6/12 lg:w-6/12 w-full flex-[0_0_auto] xl:px-[35px] lg:px-[20px] px-[15px] mt-[30px] max-w-full">
                <h3 className="text-[#343f52] text-[1.6rem] font-bold leading-[1.3] mb-5">
                  "Comprehensive Healthcare for Heroes: ECHS Ensuring Wellness
                  Beyond Service"
                </h3>
                <p className="text-[#60697b] leading-[1.6]">
                  We offers comprehensive medical care and healthcare services
                  to ex-servicemen pensioners and their dependents, providing
                  access to outpatient treatment, hospitalization, specialist
                  consultations, diagnostics, and referral services through a
                  network of polyclinics, empaneled hospitals, and diagnostic
                  centers across India.
                </p>
              </div>

              {/* Right side progress bars */}
              <div className="xl:w-6/12 lg:w-6/12 w-full flex-[0_0_auto] xl:px-[35px] lg:px-[20px] px-[15px] mt-[30px] max-w-full xl:!order-2 lg:!order-2">
                <ul className="space-y-4">
                  {progressData.map((item, index) => (
                    <li key={index} className="mb-4">
                      <div className="flex justify-between mb-2">
                        <span className="text-[#60697b] text-base">
                          {item.label}
                        </span>
                        <span className="text-[#60697b] text-base">
                          {item.value}%
                        </span>
                      </div>
                      <ProgressBar value={item.value} color={item.color} />
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className="progress-wrap fixed w-[2.3rem] h-[2.3rem] cursor-pointer block shadow-[inset_0_0_0_0.1rem_rgba(128,130,134,0.25)] z-[1010] opacity-0 invisible translate-y-3 transition-all duration-[0.2s] ease-[linear,margin-right] delay-[0s] rounded-[100%] right-6 bottom-6 motion-reduce:transition-none after:absolute after:content-['\e951'] after:text-center after:leading-[2.3rem] after:text-[1.2rem] after:text-[#605dba] after:h-[2.3rem] after:w-[2.3rem] after:cursor-pointer after:block after:z-[1] after:transition-all after:duration-[0.2s] after:ease-linear after:left-0 after:top-0 motion-reduce:after:transition-none after:font-Unicons">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            className="fill-none stroke-[#605dba] stroke-[4] box-border transition-all duration-[0.2s] ease-linear motion-reduce:transition-none"
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
          />
        </svg>
      </div>
    </>
  );
}
